document.addEventListener('DOMContentLoaded', function () {
  var logoLink = document.querySelector('.header__heading-link');
  if (!logoLink) return;
  function getCartCount() {
    var el = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (!el) return null;
    var count = parseInt(el.textContent.trim(), 10);
    return isNaN(count) ? null : count;
  }
  logoLink.addEventListener('click', function (event) {
    var cartCount = getCartCount();
    if (cartCount === null) return;
    event.preventDefault();
    var baseUrl = logoLink.getAttribute('href');
    var separator = baseUrl.includes('?') ? '&' : '?';
    var finalUrl = baseUrl + separator + 'cart_count=' + encodeURIComponent(cartCount);
    localStorage.setItem("cart_count", cartCount);
    window.location.href = finalUrl;
  });
});